import { createGlobalStyle, keyframes } from 'styled-components'
import { rgba } from 'polished'
import { bp } from 'lib/core/resources/helpers/styled'
import { CSS_CLASS } from './constants'

export const fadeInKeyframes = keyframes`
  0% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
`

export const ModalGlobalStyle = createGlobalStyle<any>`
  .${CSS_CLASS.REMOVE_SCROLL},
  .${CSS_CLASS.REMOVE_SCROLL} body {
    overflow: hidden;
  }

  .${CSS_CLASS.MODAL} {
    width: unset;
    height: unset;
    position: absolute;
    background-color: ${props => props.theme.palette.general.light};
    border-radius: 4px;
    box-shadow: 0 0 8px 0 ${props => rgba(props.theme.palette.general.dark, 0.6)};
    box-sizing: border-box;
    outline: none;
    padding: 40px 60px 30px;
    top: 50%;
    right: auto;
    bottom: auto;
    left: 50%;
    animation: forwards ${fadeInKeyframes} 200ms ease-in;
    transform: translate(-50%, -50%);
    ${bp('lg')`
      padding: 40px 30px;
    `}
    ${bp('sm')`
      height: 100vh;
      width: 100vw;
      border-radius: 0;
    `}
  }

  .${CSS_CLASS.OVERLAY} {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${props => rgba(props.theme.palette.general.dark, 0.2)};
    z-index: 10;
  }

  .${CSS_CLASS.CLOSE} {
    height: 14px;
    width: 14px;
    position: absolute;
    top: 20px;
    right: 20px;
    background: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    ${bp('lg')`
      top: 15px;
      right: 15px;
    `}

    > svg {
      path {
        stroke: ${props => props.theme.palette.general.light};
      }
    }
  }
`
